"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeTab = changeTab;
var _action_types = require("../../constants/action_types");
var _events = require("../../types/events");
function changeTab(tab) {
  return (dispatch, _getState, context) => {
    dispatch({
      type: _action_types.TABS_CHANGE_TAB_TYPE,
      tab
    });
    context.emitter.emit(_events.EEventType.TabChanged, {
      tab
    });
  };
}